<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-arrow-left mr-2" />Request Inventaris
            </h5>
            <hr />
            <b-row>
                <b-col md="4">
                    <b-form-group label="No. Request">
                        <b-form-input
                            v-model="filter.requestNumber"
                            maxlength="50"
                            placeholder="Cari No. Request"
                            @keydown.enter="getItems"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Status">
                        <b-form-select
                            v-model="filter.status"
                            :options="optFilterStatus"
                            placeholder="Pilih Status"
                        />
                    </b-form-group>
                </b-col>
                 <b-col md="4">
                    <b-form-group label="Status Inventaris">
                        <b-form-select
                            v-model="filter.statusInventory"
                            :options="optStatusInventory"
                            placeholder="Pilih Status Inventaris"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-1">
                <b-col md="4">
                    <b-form-group label="Divisi">
                        <b-form-select
                            v-model="filter.division"
                            :options="optDivision"
                            placeholder="Pilih Divisi"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Dari">
                        <b-form-input type="date" v-model="filter.from" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Sampai">
                        <b-form-input type="date" v-model="filter.to" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-1">
                <b-col md="4">
                    <b-form-group label="Kategori">
                        <multiselect
                            v-model="filter.inventoryCategory"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optInventoryCategory"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="No. Faktur PGI">
                        <b-form-input
                            v-model="filter.noFakturPgi"
                            maxlength="50"
                            placeholder="Cari No. Faktur PGI"
                            @keydown.enter="getItems"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="IMEI / SN">
                        <b-form-input
                            v-model="filter.imeiSn"
                            maxlength="50"
                            placeholder="Cari IMEI / SN"
                            @keydown.enter="getItems"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-3 align-items-center">
                <b-col md="auto">
                    <strong class="mr-2">{{ totalItemsToSend }} item dipilih</strong>
                    <b-button
                        size="sm"
                        variant="outline-danger"
                        @click="confirmResetSelection"
                        :disabled="totalItemsToSend === 0"
                    >
                        <i class="fa fa-undo mr-1" /> Reset Pilihan
                    </b-button>
                </b-col>
                <b-col class="d-flex justify-content-end align-items-start">
                    <b-form-group label="Download Excel" class="mr-2 mb-0">
                        <b-button variant="primary" @click="downloadExcel()">
                            <i class="fa fa-file-excel" /> Download
                        </b-button>
                    </b-form-group>
                    <b-form-group label="Tambah" class="mb-0">
                        <b-button variant="success" @click="confirmAddToSend()">
                            <i class="fa fa-plus" /> Kirim
                        </b-button>
                    </b-form-group>
                    <b-form-group label="Aksi" class="ml-2 mb-0">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-table
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive
                class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data pengembalian barang.
                </template>
                <template v-slot:cell(selection)="row">
                    <div v-if="row.item.status == 1">
                        <b-button
                            :id="'return-button-' + row.index"
                            :variant="row.item.selected ? 'primary' : 'dark'"
                            size="sm"
                            @click="addToSend(row.item)"
                        >
                            <i
                                :class="
                                    row.item.selected
                                        ? 'fa fa-check'
                                        : 'fa fa-minus'
                                "
                            />
                        </b-button>
                    </div>
                </template>
                <template v-slot:cell(noFaktur)="row">
                    {{ row.item.no_faktur_pgi }}
                    <div class="small text-muted">
                        <strong>{{ row.item.imei_sn }}</strong>
                    </div>
                </template>
                <template v-slot:cell(inventory)="row">
                    {{ row.item.type }}
                    <div class="small text-muted">
                        {{ row.item.kind }} -
                        {{ row.item.brand }}
                    </div>
                    <small>
                        Divisi: <strong>{{ row.item.division }}</strong>
                    </small>
                    <br />
                    <small>
                        Kategori:
                        <strong>{{ row.item.inventory_category }}</strong>
                    </small>
                    <br />
                    <small>
                        Dikirim Ke: <strong>{{ row.item.sent_to || "-" }}</strong>
                    </small>
                    <small v-if="row.item.inventory_status == 7">
                        Customer:
                        <strong>{{ row.item.customer }}</strong>
                    </small>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge
                        :variant="getStatusBadge(row.item.status)[0]"
                        :style="getStatusBadge(row.item.status)[2]"
                    >
                        {{ getStatusBadge(row.item.status)[1] }}
                    </b-badge>
                </template>
                <template v-slot:cell(inventoryStatus)="row">
                    <b-badge
                        :variant="
                            parseInventoryStatus(row.item.inventory_status)[0]
                        "
                        >{{
                            parseInventoryStatus(row.item.inventory_status)[1]
                        }}</b-badge
                    >
                    <br />
                    <span
                        v-if="row.item.inventory_status == 1"
                        class="small text-muted"
                    >
                        Barang ini perlu approve terlebih dahulu.
                    </span>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="d-flex">
                        <b-button
                            size="sm"
                            variant="primary"
                            v-b-tooltip.hover.top
                            title="Detail"
                            @click="showDetailsModal(row.item)"
                        >
                            <i class="fa fa-fw fa-info" />
                        </b-button>

                        <b-button
                            v-if="row.item.status == 1"
                            class="ml-2"
                            size="sm"
                            variant="danger"
                            v-b-tooltip.hover.top
                            title="Batalkan Request"
                            @click="confirmDeleteRequest(row.item)"
                            :disabled="isSubmitting"
                        >
                            <i class="fa fa-fw fa-times" />
                        </b-button>

                        <b-button
                            v-if="row.item.inventory_status == 7"
                            class="ml-2"
                            size="sm"
                            variant="warning"
                            v-b-tooltip.hover.top
                            title="Hapus dari Invoice"
                            @click="executeRemoveFromInvoice(row.item)"
                            :disabled="isSubmitting"
                        >
                            <i class="fa fa-fw fa-undo" />
                        </b-button>

                        <b-button
                            v-if="row.item.status === 9"
                            class="ml-2"
                            size="sm"
                            variant="success"
                            v-b-tooltip.hover.top
                            title="Approve Barang"
                            @click="executeApproveReject(row.item)"
                            :disabled="isSubmitting"
                        >
                            <i class="fa fa-fw fa-check" />
                        </b-button>
                    </div>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>

        <b-modal
            id="m-detail"
            title="Informasi Request Inventaris"
            centered
            no-close-on-backdrop
            hide-footer
        >
            <div>
                <div class="mb-2 d-flex flex-column">
                    <strong>No. Faktur</strong>
                    <span>{{ detail.no_faktur_pgi }}</span>
                </div>
                <div v-if="detail.imei_sn" class="mb-2 d-flex flex-column">
                    <strong>IMEI / SN</strong>
                    <span>{{ detail.imei_sn }}</span>
                </div>
                <div class="mb-2 d-flex flex-column">
                    <strong>Barang</strong>
                    <span>
                        {{ detail.brand }} - {{ detail.type }} -
                        {{ detail.kind }}
                    </span>
                </div>
                <div
                    class="mb-2 d-flex flex-column justify-content-start align-items-start"
                >
                    <strong>Status Inventaris:</strong>
                    <b-badge
                        :variant="
                            parseInventoryStatus(detail.inventory_status)[0]
                        "
                        >{{
                            parseInventoryStatus(detail.inventory_status)[1]
                        }}</b-badge
                    >
                </div>
                <div class="mb-2 d-flex flex-column" v-if="detail.inventory_status == 7">
                    <strong>Customer:</strong>
                    <span>{{ detail.customer }}</span>
                </div>
                <div
                    class="mb-2 d-flex flex-column justify-content-start align-items-start"
                >
                    <strong>Kategori:</strong>
                    <span>{{ detail.inventory_category}}</span>
                </div>
                <div class="mb-2 d-flex flex-column">
                    <strong>Dikirim Ke:</strong>
                    <span>{{ detail.sent_to || "-" }}</span>
                </div>
                <div class="mb-2 d-flex flex-column">
                    <strong>Divisi</strong>
                    <span>{{ detail.division }}</span>
                </div>
                <div class="mb-2 d-flex flex-column">
                    <strong>No. Request</strong>
                    <span>{{ detail.request_number }}</span>
                </div>
                <div
                    v-if="detail.reject_note || detail.reject_photo_url"
                    class="mb-2"
                >
                    <strong>Ditolak</strong><br />
                    <span v-if="detail.reject_note"
                        >Catatan: {{ detail.reject_note }}</span
                    >
                    <span class="text-muted" v-else>
                        Tidak ada catatan
                    </span>
                    <br />
                    <img
                        v-if="detail.reject_photo_url"
                        :src="detail.reject_photo_url"
                        alt="Reject Photo"
                        style="max-width: 100%; max-height: 300px; margin-top: 10px; border-radius: 4px;"
                    />
                </div>
                <div class="mb-2">
                    <strong>Log Aktivitas</strong>
                    <div v-if="detail.logs && detail.logs.items && detail.logs.items.length > 0" class="mt-2 overflow-auto" style="max-height: 300px;">
                        <div
                            v-for="log in detail.logs.items"
                            :key="log.id"
                            class="mb-2 p-2 border rounded bg-light"
                        >
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <b-badge :variant="getActionBadgeVariant(log.action)">
                                    {{ formatAction(log.action) }}
                                </b-badge>
                                <small>{{ formatDateTime(log.created_at) }}</small>
                            </div>
                            <div class="small">
                                <strong>Oleh:</strong> {{ log.performed_by }}
                                <span v-if="log.note" class="d-block mt-1">
                                    <strong>Catatan:</strong> {{ log.note }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div v-else class="mt-2 text-muted">
                        Tidak ada log aktivitas
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal
            id="m-confirm-add-to-send"
            title="Konfirmasi Kirim"
            centered
            no-close-on-backdrop
            hide-footer
            size="lg"
        >
            <span>
                Apakah Anda yakin ingin mengirim
                <strong>{{ totalItemsToSend }}</strong> barang berikut?</span
            >
            <div
                v-if="selectedItems.length > 0"
                class="mt-2 mb-2 border rounded p-2"
                style="max-height: 300px; overflow-y: auto;"
            >
                <b-table
                    :items="selectedItems"
                    :fields="previewFields"
                    bordered
                    small
                    hover
                    responsive
                    class="mb-0"
                >
                    <template v-slot:cell(noFakturImei)="row">
                        {{ row.item.no_faktur_pgi }}
                        <div class="small text-muted">
                            {{ row.item.imei_sn || "-" }}
                        </div>
                    </template>
                    <template v-slot:cell(barang)="row">
                        {{ row.item.type }}
                        <div class="small text-muted">
                            {{ row.item.kind }} - {{ row.item.brand }}
                        </div>
                    </template>
                </b-table>
            </div>
            <b-form-group label="Catatan" class="mt-2">
                <b-input
                    v-model="input.notes"
                    maxlength="200"
                    placeholder="Masukkan catatan (Opsional)"
                />
            </b-form-group>
            <div class="text-right">
                <b-button
                    variant="success"
                    @click="executeAddToSend()"
                    :disabled="isSubmitting"
                >
                    <template v-if="!isSubmitting">
                        <i class="fa fa-plus" />
                        Kirim
                    </template>
                    <template v-else>
                        <b-spinner small />
                        Kirim
                    </template>
                </b-button>
            </div>
        </b-modal>

        <b-modal
            id="m-confirm-delete-request"
            title="Konfirmasi Batalkan Request"
            centered
            no-close-on-backdrop
            hide-footer
        >
            <span>
                Apakah Anda yakin ingin membatalkan request inventaris untuk
                no. request
                <strong>{{ activeItem.request_number }}</strong
                >?</span
            >
            <b-form-group label="Catatan" class="mt-2">
                <b-input
                    v-model="input.notes"
                    maxlength="200"
                    placeholder="Masukkan alasan pembatalan"
                />
            </b-form-group>
            <div class="text-right">
                <b-button
                    variant="danger"
                    @click="executeDeleteRequest()"
                    :disabled="isSubmitting"
                >
                    <template v-if="!isSubmitting">
                        <i class="fa fa-times" />
                        Batalkan
                    </template>
                    <template v-else>
                        <b-spinner small />
                        Batalkan
                    </template>
                </b-button>
            </div>
        </b-modal>

        <b-modal
            id="m-send-success"
            title="Kirim Barang Berhasil"
            centered
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
            hide-header-close
            size="lg"
        >
            <div v-if="sendResult.sendback && sendResult.sendback.length > 0">
                <p>Barang berhasil dikirim dengan perincian sebagai berikut:</p>
                <ul class="mt-2 mb-3">
                    <li
                        v-for="item in sendResult.sendback.slice(0, 10)"
                        :key="item.inventory_request_number"
                    >
                        No. Faktur:
                        <strong>{{ item.no_faktur }}</strong> &mdash; No.
                        Request:
                        <strong>{{ item.inventory_request_number }}</strong>
                    </li>
                    <li v-if="sendResult.sendback.length > 10">
                        dan <strong>{{ sendResult.sendback.length - 10 }}</strong> barang
                        lainnya berhasil dikirim.
                    </li>
                </ul>

                <div class="mb-3">
                    Tekan bagian "Sinar Mutiara Cell" untuk mencetak faktur.
                </div>

                <b-carousel
                    id="invoice-carousel"
                    v-model="carouselSlide"
                    :interval="0"
                    :controls="false"
                    :indicators="false"
                >
                    <b-carousel-slide
                        v-for="(invoice, index) in sendResult.sendback"
                        :key="index"
                    >
                        <template #img>
                            <iframe
                                :src="
                                    $BASE_PRINT_FILE_PATH +
                                        getInvoiceLink(invoice)
                                "
                                height="300px"
                                width="100%"
                                style="border: 1px solid #ddd; border-radius: 4px;"
                            />
                        </template>
                    </b-carousel-slide>
                </b-carousel>

                <div class="mt-2 text-center">
                    <small class="text-muted">
                        <strong>{{
                            sendResult.sendback[carouselSlide].no_faktur
                        }}</strong>
                        -
                        <strong>{{
                            sendResult.sendback[carouselSlide].inventory_request_number
                        }}</strong>
                    </small>
                </div>

                <div
                    v-if="sendResult.sendback.length > 1"
                    class="d-flex justify-content-center align-items-center mt-3"
                >
                    <b-button
                        variant="outline-primary"
                        @click="previousInvoice"
                        :disabled="carouselSlide === 0"
                        class="mr-3"
                    >
                        <i class="fa fa-chevron-left" />
                    </b-button>
                    <span class="mx-3">
                        <strong>{{ carouselSlide + 1 }}</strong> /
                        {{ sendResult.sendback.length }}
                    </span>
                    <b-button
                        variant="outline-primary"
                        @click="nextInvoice"
                        :disabled="carouselSlide === sendResult.sendback.length - 1"
                        class="ml-3"
                    >
                        <i class="fa fa-chevron-right" />
                    </b-button>
                </div>

                <div class="mt-4">
                    <b-row>
                        <b-col md="6">
                            <b-button
                                variant="dark"
                                :disabled="invoiceSizeCooldown"
                                @click="toggleInvoiceSize"
                            >
                                Print {{ invoiceSize == "A5" ? "A4" : "A5" }}
                            </b-button>
                        </b-col>
                        <b-col md="6" class="text-right">
                            <b-button
                                variant="primary"
                                @click="closeSendSuccess"
                            >
                                OK
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </b-modal>

        <b-modal
            id="m-send-result"
            title="Hasil Pengiriman"
            centered
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
            hide-header-close
            size="lg"
        >
            <div class="mb-3 text-muted small">
                Berhasil: <strong class="text-dark">{{ sendResult.success ? sendResult.success.length : 0 }} barang</strong>
                &nbsp;&bull;&nbsp;
                Gagal: <strong :class="(sendResult.failed && sendResult.failed.length > 0) ? 'text-danger' : 'text-dark'">{{ sendResult.failed ? sendResult.failed.length : 0 }} barang</strong>
                &nbsp;&bull;&nbsp;
                {{ groupedSendResult.length }} grup pengiriman 
            </div>

            <div
                style="max-height: 70vh; overflow-y: auto;"
            >
                <div
                    v-for="(group) in groupedSendResult"
                    :key="group.key"
                    class="mb-3"
                >
                    <div
                        class="d-flex align-items-center mb-2 p-2 rounded"
                        :class="{
                            'bg-success text-white': group.status === 'success',
                            'bg-danger text-white': group.status === 'failed',
                            'bg-warning text-dark': group.status === 'null_synced'
                        }"
                    >
                        <i
                            :class="{
                                'fa fa-check-circle': group.status === 'success',
                                'fa fa-times-circle': group.status === 'failed',
                                'fa fa-exclamation-triangle': group.status === 'null_synced'
                            }"
                            class="mr-2"
                        />
                        <div class="flex-grow-1">
                            <template v-if="group.status !== 'null_synced'">
                                <strong>{{ group.request_number }}</strong>
                                <span class="ml-2" style="font-size: 0.85rem; opacity: 0.9;">
                                    — Divisi: {{ group.division }}
                                </span>
                            </template>
                            <template v-else>
                                <strong>Gagal Validasi</strong>
                                <span class="ml-2" style="font-size: 0.85rem; opacity: 0.85;">
                                    — Tidak dikirim ke GA (validasi gagal di sistem)
                                </span>
                            </template>
                        </div>
                        <small style="opacity: 0.9;">{{ group.items.length }} barang</small>
                    </div>

                    <!-- Banner alasan batch gagal -->
                    <div
                        v-if="group.status === 'failed' && group.offenderCount > 0"
                        class="alert alert-danger py-2 px-3 mb-2 small"
                    >
                        <i class="fa fa-exclamation-circle mr-1" />
                        Gagal kirim ke GA. {{ group.offenderCount }} dari {{ group.total }} barang bermasalah, semua batal terkirim.
                    </div>

                    <!-- Tabel barang -->
                    <div class="border rounded p-2" style="max-height: 250px; overflow-y: auto;">
                        <b-table
                            :items="group.items"
                            :fields="group.status === 'success' ? [
                                { key: 'noFakturImei', label: 'No. Faktur / IMEI' },
                                { key: 'barang', label: 'Barang' }
                            ] : [
                                { key: 'noFakturImei', label: 'No. Faktur / IMEI' },
                                { key: 'barang', label: 'Barang' },
                                { key: 'reason', label: 'Keterangan' }
                            ]"
                            bordered
                            small
                            hover
                            responsive
                            class="mb-0"
                        >
                            <template v-slot:cell(noFakturImei)="row">
                                <span
                                    v-if="row.item.error_code"
                                    class="text-danger mr-1"
                                    title="Barang ini yang ditolak GA"
                                >&#9679;</span>
                                {{ row.item.inventory ? row.item.inventory.no_faktur_pgi : '-' }}
                                <div class="small text-muted">
                                    {{ row.item.inventory ? row.item.inventory.imei_sn : '-' }}
                                </div>
                            </template>
                            <template v-slot:cell(barang)="row">
                                {{ row.item.inventory ? row.item.inventory.type : '-' }}
                                <div class="small text-muted">
                                    {{ row.item.inventory ? row.item.inventory.kind : '-' }} — {{ row.item.inventory ? row.item.inventory.brand : '-' }}
                                </div>
                            </template>
                            <template v-slot:cell(reason)="row">
                                <span v-if="row.item.reason" class="small">{{ row.item.reason }}</span>
                                <span v-else class="text-muted small">-</span>
                            </template>
                        </b-table>
                    </div>
                </div>

                <div v-if="groupedSendResult.length === 0" class="text-center text-muted py-3">
                    Tidak ada data hasil pengiriman.
                </div>
            </div>

            <div class="mt-4">
                <b-row>
                    <b-col md="6" class="text-left">
                        <b-button
                            v-if="sendResult.success && sendResult.success.length > 0"
                            variant="primary"
                            @click="showInvoiceModal"
                        >
                            <i class="fa fa-file-invoice" /> Lihat Invoice
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right" v-if="sendResult.success && sendResult.success.length <= 0">
                        <b-button variant="secondary" @click="closeSendResult">
                            OK
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal
            id="m-download"
            title="Download Excel Laporan"
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            hide-header-close
            ref="downloadModal"
        >
            <template #modal-title>
                Download Excel Laporan
                <button
                    type="button"
                    class="close"
                    aria-label="Close"
                    :disabled="isSubmitting"
                    @click="$refs.downloadModal.hide()"
                    style="position: absolute; top: 0.5rem; right: 1rem;"
                >
                    <b-spinner small v-if="isSubmitting" />
                    <span v-else aria-hidden="true">&times;</span>
                </button>
            </template>
            <div v-if="isSubmitting">
                Menyiapkan file Excel, mohon menunggu...
            </div>
            <div v-else-if="isDownloadExcelError">
                Gagal menyiapkan laporan. Silahkan coba lagi, atau perpendek
                jarak antara tanggal mulai dan selesai file Excel!
            </div>
            <div v-else>
                File Excel sudah siap. Tekan tombol dibawah ini untuk download
                file Excel.
                <div class="mt-2">
                    <a :href="reportPath" download>
                        <b-button variant="primary">
                            <i class="fa fa-download mr-2" />Download Excel File
                            Excel
                        </b-button>
                    </a>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,
            isDownloadExcelError: false,

            filter: {
                division: null,
                status: -1,
                requestNumber: "",
                from: "",
                to: "",
                inventoryCategory: null,
                noFakturPgi: "",
                imeiSn: "",
                statusInventory: -1
            },

            input: {
                notes: ""
            },

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            fields: [
                { key: "selection", label: "Pilih", sortable: false },
                {
                    key: "noFaktur",
                    label: "No. Faktur / IMEI",
                    sortable: false
                },
                {
                    key: "request_number",
                    label: "No. Request",
                    sortable: false
                },
                { key: "inventory", label: "Barang", sortable: false },
                { key: "status", label: "Status", sortable: false },
                {
                    key: "inventoryStatus",
                    label: "Status Inventaris",
                    sortable: false
                },
                { key: "action", label: "Aksi" }
            ],

            previewFields: [
                { key: "noFakturImei", label: "No. Faktur / IMEI" },
                { key: "barang", label: "Barang" },
                { key: "request_number", label: "No. Request" }
            ],

            items: [],
            detail: {},
            activeItem: {
                id: null,
                inventory: {}
            },
            selectedItemsReactive: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            reportPath: "",

            optFilterStatus: [
                { value: -1, text: "Semua" },
                { value: 1, text: "Disetujui" },
                { value: 2, text: "Dikirim" },
                { value: 3, text: "Dibatalkan" },
                { value: 4, text: "Tiba di PGI" },
                { value: 9, text: "Ditolak" }
            ],
            optInventoryCategory: [],
            optDivision: [],

            sendResult: { success: [], sendback: [], failed: [] },
            invoiceSize: "A5",
            invoiceSizeCooldown: false,
            carouselSlide: 0,
            optStatusInventory: [
                { value: -1, text: "Semua" },
                { value: 1, text: "PENDING" },
                { value: 2, text: "READY" },
                { value: 7, text: "DRAFT" },
                { value: 3, text: "TERJUAL" },
                { value: 4, text: "RETUR" },
                { value: 5, text: "HILANG" },
                { value: 55, text: "REQUEST HILANG" },
                { value: 6, text: "KIRIM BALIK PGI" },
                { value: 66, text: "REQUEST KIRIM BALIK" },
                { value: 8, text: "REQUEST RESET" },
                { value: 9, text: "REQUEST MOVE" },
                { value: 10, text: "INVENTARIS" },
                { value: 11, text: "REQUEST INVENTARIS" },
                { value: 14, text: "DALAM PERJALANAN" },
            ],
        };
    },

    methods: {
        init() {
            this.initStatus = 0;
            let getItems = this.getItems();
            let getDivisions = this.$axios
                .get("division/get-all-filtered")
                .then(res => {
                    res.data.data = res.data.data.map(item => {
                        return { value: item.id, text: item.name };
                    });
                    res.data.data.unshift({
                        value: null,
                        text: "Semua"
                    });

                    this.optDivision = res.data.data;
                });
            let getInventoryCategory = this.$axios
                .get("master/inventory-category")
                .then(res => {
                    this.optInventoryCategory = res.data.data;
                });

            Promise.all([getItems, getDivisions, getInventoryCategory])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch(() => {
                    this.initStatus = -1;
                });
        },

        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage,
                true
            );

            if (!this.$helper.isBlank(this.filter.requestNumber)) {
                param += "&request_number=" + this.filter.requestNumber;
            }

            if (this.filter.status != -1) {
                param += "&status=" + this.filter.status;
            }

            if (!this.$helper.isBlank(this.filter.division)) {
                param += "&division_id=" + this.filter.division;
            }

            if (!this.$helper.isBlank(this.filter.from)) {
                param += "&from=" + this.filter.from;
            }

            if (this.filter.inventoryCategory != null) {
                param +=
                    "&inventory_category_id=" +
                    this.filter.inventoryCategory.id;
            }

            if (!this.$helper.isBlank(this.filter.to)) {
                param += "&to=" + this.filter.to;
            }

            if (!this.$helper.isBlank(this.filter.noFakturPgi)) {
                param += "&no_faktur_pgi=" + this.filter.noFakturPgi;
            }

            if (!this.$helper.isBlank(this.filter.imeiSn)) {
                param += "&imei_sn=" + this.filter.imeiSn;
            }

            if (this.sortBy != null) {
                param +=
                    "&sortBy=" + this.sortBy + "&sortDesc=" + this.sortDesc;
            }

             if (this.filter.statusInventory != -1) {
                param += "&status_inventory=" + this.filter.statusInventory;
            }

            return this.$axios
                .get("request-inventory-pgi" + param)
                .then(res => {
                    this.selectedItemsReactive = JSON.parse(localStorage.getItem("listRequestInven_selected") || "[]");
                    this.items = res.data.data.items.map(item => {
                        item.selected = this.selectedItemsReactive.some(s => s.id === item.id);
                        return item;
                    });

                    this.totalRows = res.data.data.total;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        showDetailsModal(item) {
            this.$bvModal.show("m-detail");
            this.activeItem = item;
            this.getDetail(item);
        },

        getDetail(item) {
            this.isBusy = true;
            return this.$axios
                .get("request-inventory-pgi/detail/" + item.id)
                .then(res => {
                    console.log(res.data.data);
                    this.detail = res.data.data;
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isBusy = false));
        },

        addToSend(item) {
            this.activeItem = item;
            item.selected = !item.selected;

            if (item.selected) {
                if (!this.selectedItemsReactive.some(s => s.id === item.id)) {
                    this.selectedItemsReactive.push({
                        id: item.id,
                        no_faktur_pgi: item.no_faktur_pgi,
                        imei_sn: item.imei_sn,
                        kind: item.kind,
                        brand: item.brand,
                        type: item.type,
                        request_number: item.request_number
                    });
                }
            } else {
                this.selectedItemsReactive = this.selectedItemsReactive.filter(s => s.id !== item.id);
            }
            localStorage.setItem("listRequestInven_selected", JSON.stringify(this.selectedItemsReactive));
        },

        confirmResetSelection() {
            if (!confirm("Hapus semua pilihan barang?")) return;
            this.selectedItemsReactive = [];
            localStorage.removeItem("listRequestInven_selected");
            this.items.forEach(item => {
                item.selected = false;
            });
        },

        confirmAddToSend() {
            if (this.totalItemsToSend === 0) {
                this.$helper.toastError(
                    this,
                    "Silakan pilih barang terlebih dahulu"
                );
                return;
            }

            this.input.notes = "";
            this.$bvModal.show("m-confirm-add-to-send");
        },

        executeAddToSend() {
            this.isSubmitting = true;

            let payload = {
                sendback_request_item_ids: this.selectedIds,
                note: this.input.notes
            };

            this.$axios
                .post("request-inventory-pgi/send", payload)
                .then(res => {
                    this.$bvModal.hide("m-confirm-add-to-send");
                    this.sendResult = res.data.data;
                    this.$bvModal.show("m-send-result");
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        executeApproveReject(item) {
            this.input.notes = "";
            this.activeItem = item;

            let isConfirmed = confirm(
                `Apakah Anda yakin ingin menyetujui penolakan request inventaris no. ${
                    item.request_number
                }?`
            );
            if (!isConfirmed) return;

            this.isSubmitting = true;

            this.$axios
                .patch("request-inventory-pgi/approve/" + this.activeItem.id)
                .then(() => {
                    this.$helper.toastSuccess(
                        this,
                        "Request berhasil ditolak!"
                    );
                    this.getItems(this.currentPage);
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        executeRemoveFromInvoice(item) {
            let isConfirmed = confirm(
                `Hapus barang ${item.type} dengan No. Request ${
                    item.request_number
                } dari invoice? Status inventaris akan berubah menjadi READY!`
            );
            if (!isConfirmed) return;

            this.isSubmitting = true;
            this.$axios
                .post("request-inventory-pgi/remove-from-invoice", {
                    sendback_request_item_id: item.id
                })
                .then(() => {
                    this.$helper.toastSuccess(
                        this,
                        "Barang berhasil dihapus dari invoice! Status inventaris berubah menjadi READY!"
                    );
                    this.getItems(this.currentPage);
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        confirmDeleteRequest(item) {
            this.input.notes = "";
            this.activeItem = item;
            this.$bvModal.show("m-confirm-delete-request");
        },

        executeDeleteRequest() {
            if (this.$helper.isBlank(this.input.notes)) {
                return this.$helper.toastError(
                    this,
                    "Mohon mengisi alasan pembatalan!"
                );
            }

            this.isSubmitting = true;

            let payload = {
                sendback_request_item_id: this.activeItem.id,
                note: this.input.notes
            };

            this.$axios
                .post("request-inventory-pgi/cancel-item", payload)
                .then(() => {
                    this.$bvModal.hide("m-confirm-delete-request");
                    this.$helper.toastSuccess(
                        this,
                        "Request berhasil dibatalkan!"
                    );
                    this.getItems(this.currentPage);

                    this.input.notes = "";
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        downloadExcel() {
            this.isDownloadExcelError = false;
            this.isSubmitting = true;

            const payload = {
                status: this.filter.status == -1 ? null : this.filter.status,
                division_id: this.filter.division,
                request_number: this.filter.requestNumber,
                inventory_category_id: this.filter.inventoryCategory
                    ? this.filter.inventoryCategory.id
                    : null,
                from: this.filter.from,
                to: this.filter.to,
                no_faktur_pgi: this.filter.noFakturPgi,
                imei_sn: this.filter.imeiSn
            };

            this.$bvModal.show("m-download");
            this.$axios
                .post("request-inventory-pgi/excel-report", payload, {
                    timeout: 600000
                })
                .then(res => {
                    this.reportPath = res.data.data.path;
                })
                .catch(error => {
                    this.isDownloadExcelError = true;
                    this.$helper.parseError(this, error);
                })
                .finally(() => (this.isSubmitting = false));
        },

        processLostItem() {
            this.$bvModal.hide("m-detail");
            this.$bvModal.hide("m-faktur-hp");
            this.$helper.toastSuccess(
                this,
                "IMEI/No.Faktur " + this.number + " berhasil dinyatakan hilang!"
            );
            this.number = "";
            this.noFaktur = "";
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getItems();
        },

        parseInventoryStatus(status) {
            switch (status) {
                case 1:
                    return ["warning", "PENDING"];
                case 2:
                    return ["dark", "READY"];
                case 3:
                    return ["success", "TERJUAL"];
                case 4:
                    return ["warning", "RETUR"];
                case 5:
                    return ["danger", "HILANG"];
                case 6:
                    return ["primary", "KIRIM BALIK PGI"];
                case 66:
                    return ["primary", "REQUEST KIRIM BALIK PGI"];
                case 7:
                    return ["light", "DRAFT"];
                case 55:
                    return ["dark", "REQUEST HILANG"];
                case 8:
                    return ["dark", "REQUEST RESET"];
                case 10:
                    return ["primary", "INVENTARIS"];
                case 14:
                    return ["primary", "DALAM PERJALANAN"];
                case 11:
                    return ["primary", "REQUEST INVENTARIS"];
                case 9:
                    return ["primary", "REQUEST MOVE"];
                default:
                    return ["light", "-"];
            }
        },

        getStatusBadge(status) {
            const APPROVED = 1;
            const SHIPMENT = 2;
            const CANCELED = 3;
            const RECEIVED = 4;
            const REJECT = 9;

            switch (status) {
                case APPROVED:
                    return ["primary", "DISETUJUI"];
                case SHIPMENT:
                    return [
                        "",
                        "DIKIRIM",
                        { backgroundColor: "#5d5a5e", color: "#fff" }
                    ];
                case CANCELED:
                    return ["danger", "DIBATALKAN"];
                case RECEIVED:
                    return ["success", "TIBA DI PGI"];
                case REJECT:
                    return ["danger", "DITOLAK"];
                default:
                    return ["light", "-"];
            }
        },

        getInvoiceLink(invoice) {
            if (!invoice) {
                return "";
            }

            const cleanPath = path => (path || "").replace(/\\/g, "");

            if (this.invoiceSize === "A5") {
                const linkA5 = cleanPath(invoice.link);
                return linkA5 || cleanPath(invoice.link4);
            }

            const linkA4 = cleanPath(invoice.link4);
            return linkA4 || cleanPath(invoice.link);
        },

        toggleInvoiceSize() {
            this.invoiceSizeCooldown = true;
            if (this.invoiceSize == "A5") {
                this.invoiceSize = "A4";
            } else {
                this.invoiceSize = "A5";
            }
            setTimeout(() => {
                this.invoiceSizeCooldown = false;
            }, 2000);
        },

        closeSendSuccess() {
            this.$bvModal.hide("m-send-success");

            this.selectedItemsReactive = [];
            localStorage.removeItem("listRequestInven_selected");
            this.getItems(this.currentPage);
            this.input.notes = "";

            this.sendResult = { success: [], sendback: [], failed: [] };
            this.invoiceSize = "A5";
            this.carouselSlide = 0;
        },

        closeSendResult() {
            this.$bvModal.hide("m-send-result");

            this.selectedItemsReactive = [];
            localStorage.removeItem("listRequestInven_selected");
            this.getItems(this.currentPage);
            this.input.notes = "";

            this.sendResult = { success: [], sendback: [], failed: [] };
        },

        showInvoiceModal() {
            this.$bvModal.hide("m-send-result");
            this.$bvModal.show("m-send-success");
        },

        previousInvoice() {
            if (this.carouselSlide > 0) {
                this.carouselSlide--;
            }
        },

        nextInvoice() {
            if (this.carouselSlide < this.sendResult.sendback.length - 1) {
                this.carouselSlide++;
            }
        },

        formatAction(action) {
            const actionMap = {
                CREATE_REQUEST: "Dibuat",
                CANCELED_REQUEST: "Dibatalkan",
                SEND_REQUEST: "Dikirim",
                REJECT_REQUEST: "Ditolak",
                RE_APPROVED: "Disetujui Ulang",
                REMOVE_FROM_INVOICE: "Dihapus dari Invoice",
                ARRIVED: "Tiba di PGI"
            };
            return actionMap[action] || action;
        },

        getActionBadgeVariant(action) {
            const variantMap = {
                CREATE_REQUEST: "primary",
                CANCELED_REQUEST: "danger",
                SEND_REQUEST: "info",
                REJECT_REQUEST: "warning",
                RE_APPROVED: "success",
                REMOVE_FROM_INVOICE: "secondary",
                ARRIVED: "success"
            };
            return variantMap[action] || "light";
        },

        formatDateTime(dateTime) {
            if (!dateTime) return "";
            return new Date(dateTime).toLocaleString("id-ID", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit"
            });
        }
    },

    computed: {
        selectedItems() {
            return this.selectedItemsReactive;
        },
        totalItemsToSend() {
            return this.selectedItemsReactive.length;
        },
        selectedIds() {
            return this.selectedItemsReactive.map(item => item.id);
        },

        groupedSendResult() {
            const groups = {};
            const nullSyncedItems = [];

            const successItems = (this.sendResult && this.sendResult.success) || [];
            const failedItems = (this.sendResult && this.sendResult.failed) || [];
            const allItems = [
                ...successItems.map(i => ({ ...i, _status: 'success' })),
                ...failedItems.map(i => ({ ...i, _status: 'failed' }))
            ];

            allItems.forEach(item => {
                // ga_synced = null → gagal validasi lokal, belum pernah dikirim ke GA
                if (item.ga_synced === null) {
                    nullSyncedItems.push(item);
                    return;
                }

                // ga_synced = true/false → bagian dari 1 GA hit, group by request_number + division_id
                const key = `${item.request_number}__${item.division_id}`;
                if (!groups[key]) {
                    groups[key] = {
                        key,
                        request_number: item.request_number,
                        division: item.division || '-',
                        division_id: item.division_id,
                        status: item._status,
                        reason: null,
                        items: []
                    };
                }
                if (item._status === 'failed' && !groups[key].reason && item.reason) {
                    groups[key].reason = item.reason;
                }
                groups[key].items.push(item);
            });

            // Offender per GA-hit dari BE, di-key sama seperti grup (request_number + division_id).
            const batchFailures = (this.sendResult && this.sendResult.ga_batch_failures) || [];
            const offenderByKey = {};
            batchFailures.forEach(b => {
                offenderByKey[`${b.request_number}__${b.division_id}`] = b.offenders || [];
            });

            Object.values(groups).forEach(group => {
                if (group.status !== 'failed') return;
                const offenders = offenderByKey[group.key] || [];
                group.offenderCount = offenders.length;
                group.total = group.items.length;
                group.items.sort((a, b) => {
                    const ao = a.error_code ? 0 : 1;
                    const bo = b.error_code ? 0 : 1;
                    return ao - bo;
                });
            });

            const result = Object.values(groups).sort((a, b) => {
                if (a.status === b.status) return 0;
                return a.status === 'success' ? -1 : 1;
            });

            // Tambahkan grup ga_synced=null di paling bawah (setelah semua GA hit group)
            if (nullSyncedItems.length > 0) {
                result.push({
                    key: '__null_synced__',
                    request_number: null,
                    division: null,
                    division_id: null,
                    status: 'null_synced',
                    reason: 'Gagal validasi sebelum dikirim ke GA',
                    items: nullSyncedItems
                });
            }

            return result;
        }
    },

    created() {
        this.init();
    }
};
</script>
